/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicWebclientBarbersQueryResponse, GetApiPublicWebclientBarbersQueryParams, GetApiPublicWebclientBarbers400, GetApiPublicWebclientBarbers404 } from "../entities/GetApiPublicWebclientBarbers";

function getGetApiPublicWebclientBarbersUrl() {
  const res = { method: 'GET', url: `/api/public/webclient/barbers` as const }
  return res
}

/**
 * @description Активные мастера компании выбранной услуги из филиалов, где эта услуга продаётся, с ближайшим доступным слотом. Время рассчитывается по 30-минутным слотам
 * @summary Получить доступных мастеров (онлайн-запись)
 * {@link /api/public/webclient/barbers}
 */
export async function getApiPublicWebclientBarbers(params: GetApiPublicWebclientBarbersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiPublicWebclientBarbersQueryResponse, ResponseErrorConfig<GetApiPublicWebclientBarbers400 | GetApiPublicWebclientBarbers404>, unknown>({ method : "GET", url : getGetApiPublicWebclientBarbersUrl().url.toString(), params, ... requestConfig })
  return res.data
}